import { CustomDomainData } from '../types';

export function getCachedDomainData() {
  const domainData = localStorage.getItem('domainData');
  if (domainData) {
    return JSON.parse(domainData) as CustomDomainData;
  }
}
